<template>
  <benefit-notification-box-base :icon-path="'subscription/discount.svg'" :description="description" :title="title"/>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import BenefitNotificationBoxBase from '@/base-components/BenefitNotificationBoxBase';

export default {
  name: 'FreeMonthsBenefitNotificationBox',
  components: {
    BenefitNotificationBoxBase,
  },
  computed: {
    ...mapState('benefits', ['benefitType', 'benefitAmount']),
    ...mapGetters('benefits', ['BENEFIT_TYPES']),
    description() {
      return `חודש ניסיון + ${this.monthFreeString} במנוי בחינם! משלמים רק מהחודש ה-${this.monthToStartPaying} לשימוש, ₪45 לחודש.`;
    },
    monthFreeString() {
      if (this.benefitAmount === 1) {
        return 'חודש נוסף';
      }
      if (this.benefitAmount === 2) {
        return 'חודשיים נוספים';
      }
      return `${this.benefitAmount} חודשים נוספים`;
    },
    monthToStartPaying() {
      return this.benefitAmount + 2;
    },
    title() {
      return 'מגיעה לך הטבה בתשלום!';
    },
  },
};
</script>

<style scoped lang="scss">
</style>
